import { Component, ChangeDetectionStrategy, Output, EventEmitter, ElementRef, Input } from '@angular/core';
export class AmdOptionComponent {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.optionClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    get content() {
        return (this.nativeElement.textContent || '').trim(); // [TODO] - remove direct DOM acces
    }
    /**
     * @return {?}
     */
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    /**
     * @return {?}
     */
    onClick() {
        this.optionClick.emit();
    }
}
AmdOptionComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-option',
                template: "<div class=\"amd-option amd-menu__item\" (click)=\"onClick()\"> <ng-content></ng-content> </div>",
                changeDetection: ChangeDetectionStrategy.OnPush
            },] },
];
/**
 * @nocollapse
 */
AmdOptionComponent.ctorParameters = () => [
    { type: ElementRef, },
];
AmdOptionComponent.propDecorators = {
    'optionClick': [{ type: Output },],
    'value': [{ type: Input },],
};
function AmdOptionComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdOptionComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdOptionComponent.ctorParameters;
    /** @type {?} */
    AmdOptionComponent.propDecorators;
    /** @type {?} */
    AmdOptionComponent.prototype.optionClick;
    /** @type {?} */
    AmdOptionComponent.prototype.value;
    /** @type {?} */
    AmdOptionComponent.prototype.elementRef;
}
//# sourceMappingURL=option.component.js.map
//# sourceMappingURL=option.component.js.map
